import { useEffect, useState } from 'react'
import { FiTrash2 } from 'react-icons/fi'

type AddQuestionsProps = {
  title: string
  question: NewQuestionType
  deleteQuestion: Function
  buttonColor: string
  canDelete?: boolean
  setOptional: Function
}


type NewQuestionType = {
  sort: number
  value: string
  optional: number
  updated_by: string
}

export const ShowQuestions = ({ title, question, deleteQuestion, buttonColor, canDelete = true, setOptional }: AddQuestionsProps) => {
  const [required, setRequired] = useState<boolean>(false)

  useEffect(() => {
    if (question.optional == 1) {
      setRequired(true)
    } else {
      setRequired(false)
    } 
  },[question.optional, setOptional])


  return (
    <div className="show-questions-container">
      <div className="collection-questions-container">
        <p>{title}</p>
        {question &&
          <div className="collection-questions-wrapper">
            <span className="questions-span" key={question.value}>{question.value}</span>
            {canDelete && (
              <button className="btn-icon" style={{ backgroundColor: buttonColor }} onClick={() => { deleteQuestion(question) }}>
                <FiTrash2 />
              </button>
            )}

            <div
              className="checkbox-show-picture"
              style={{ padding: '10px 25px', margin: '5px' }}
            >
              <input 
                type="checkbox" 
                checked={required}
                onClick={() => {
                  setOptional(question, !required); setRequired(!required)
                }}
              />
              Required
            </div>
          </div>
        }
      </div>
    </div>
  )
}